export const MAXIMUM_FILTERS_ITEM_COUNT_MOBILE = 8; // hard limit on how many filters on mobile to prevent more than 3 lines of filters
export const DEFAULT_GRID_BREAKPOINTS_CONFIG = { md: 3 as const, sm: 6 as const, xs: 12 as const };
export const CARD_LIST_BREAKPOINTS_CONFIG = { md: 6 as const, sm: 6 as const, xs: 12 as const };
export const DESKTOP_LIST_IMAGE_CONFIG = { width: 304, height: 171 };
export const MOBILE_CARD_IMAGE_CONFIG = { width: 80, height: 80 };
export const PAGE_HEADER_HEIGHT = 120; // height in pixels for margin of scrolling back after collapsing show more
